<template>
  <div class="about-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="kindergarten-about-image">
            <div class="main-image">
              <img :src="getImgUrl('resimler', image.image_image)" alt="image" v-for="image of images"
                :key="image.image_id">
            </div>
            <div class="shape">
              <img src="../../assets/img/shape/kite1.png" alt="image">
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="about-content" v-for="title of titles" :key="title.title_id">
            <span class="sub-title">{{ title.title_title }}</span>
            <h2 class="font-weight-black">{{ title.title_header }}</h2>
            <p>{{ title.title_content }}</p>
            <ul class="about-list">
              <li v-for="aboutusitem of aboutus" :key="aboutusitem.aboutus_id"><span><i class='bx bx-check'></i> {{ aboutusitem.aboutus_name }}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="kindergarten-shape7">
      <img src="../../assets/img/kindergarten-shape/k-shape7.png" alt="image">
    </div>
    <div class="kindergarten-shape8">
      <img src="../../assets/img/kindergarten-shape/k-shape8.png" alt="image">
    </div>
  </div>
</template>

<script>

import axios from "axios";


export default {
  name: 'AboutUs',
  props: ['pathUrl'],
  created() {
    this.getTitles();
    this.getAboutus();
    this.getImages();
  },
  data() {
    return {
      titles: [],
      aboutus: [],
      images: [],
      errors: []
    };
  },
  methods: {
    getTitles() {
      axios.get(this.pathUrl + "?data=title&parent=3")
        .then(response => (this.titles = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getAboutus() {
      axios.get(this.pathUrl + "?data=aboutus")
        .then(response => (this.aboutus = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getImages() {
      axios.get(this.pathUrl + "?data=image&parent=3")
        .then(response => (this.images = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getImgUrl(category, pet) {
      return require('../../../../assets/resimler/' + category + '/' + pet)
    }
  }
}
</script>